import {CONFIG} from "../constants";

export function openMeeting(meetingId: string, token: string, who: "client"|"coach") {
  let userName = window.localStorage[CONFIG.USERNAME_TOKEN]
  let name = userName.split(' ')[0]
  let url = CONFIG.MEETING_HOST + "?name=" + name + "&who=" + who + "&back=" + window.location.href
  let meetingType = meetingId.startsWith("team_") ? "team" : "coaching";
  url += "&meetingKey=" + meetingId;
  url += "&meetingType=" + meetingType;
  url += "&userId=" + window.localStorage[CONFIG.PERSON_TOKEN];
  url += "&token=" + token;
  window.location.href = url;
}